import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { ThemeProvider } from "@emotion/react";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import Login from "../Pages/Login/login";
// local modules
import theme from "../Theme";
import Layout from "../Pages/Layout/layout";
import { persistor, store } from "../Redux/store";
import { Box, CircularProgress } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { pdfjs } from "react-pdf";
import "react-toastify/dist/ReactToastify.css";
// react-slick
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { checkAppVersion } from "../Utility/versionCheck";
import { LicenseInfo } from "@mui/x-license-pro";
import { getMUILicensekey } from "../Configs";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProjectRoutes from "../Routes/index";
// react pdf config
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const App2 = () => {
  LicenseInfo.setLicenseKey(getMUILicensekey());

  // const userInfo = useSelector((state) => state.login.value);

  useEffect(() => {
    checkAppVersion();
  }, []);

  return (
    <BrowserRouter>
      <ProjectRoutes />
    </BrowserRouter>
  );

  // return userInfo?.UserID ? <Layout /> : <Login />;
  // return true ? <Layout /> : <Login />;
};
const App = () => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ToastContainer />
            <App2 />
            <div
              id="loader"
              style={{ display: "none" }}
              className="mui-spinner"
            >
              <Box position="relative" display="inline-flex">
                <Box
                  sx={{
                    position: "absolute",
                    inset: 0,
                    border: "4px solid #fff",
                    borderRadius: "50%",
                  }}
                />
                <CircularProgress
                  size={60}
                  thickness={4}
                  sx={{ animationDuration: "800ms" }}
                />
              </Box>
            </div>
          </PersistGate>
        </Provider>
      </ThemeProvider>
    </LocalizationProvider>
  );
};

export default App;
